/* AIR VELA — scripts propios (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.av-reveal:not(.av-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('av-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('av-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var heros = document.querySelectorAll('[data-av-parallax]');
    if (!heros.length || reduce) return;
    var ticking = false;
    function update() {
      heros.forEach(function (h) {
        var media = h.classList.contains('av-hero--partido') ? h.querySelector('.av-hero__media img') : h.querySelector('.av-hero__media');
        if (h.classList.contains('av-hero--partido') && window.innerWidth < 990) { if (media) media.style.transform = ''; return; }
        if (!media) return;
        var intensidad = parseFloat(h.getAttribute('data-av-parallax')) || 0;
        var r = h.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        media.style.transform = 'translate3d(0,' + (-r.top * intensidad / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCifras(root) {
    var els = (root || document).querySelectorAll('[data-av-count]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-av-count')) || 0;
      if (reduce) { el.textContent = fin; return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(fin * e);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCabezales(root) {
    (root || document).querySelectorAll('[data-av-cab]').forEach(function (sec) {
      var img = sec.querySelector('.av-cab__visual img');
      var etiqueta = sec.querySelector('.av-cab__etiqueta');
      var items = sec.querySelectorAll('.av-cab__item');
      if (!img || !items.length) return;
      function activar(item) {
        items.forEach(function (i) { i.classList.remove('av-activo'); });
        item.classList.add('av-activo');
        var src = item.getAttribute('data-img');
        if (etiqueta) etiqueta.textContent = item.getAttribute('data-nombre') || '';
        if (src && img.getAttribute('src') !== src) {
          img.classList.add('av-cambiando');
          setTimeout(function () {
            img.setAttribute('src', src);
            img.removeAttribute('srcset');
            img.onload = function () { img.classList.remove('av-cambiando'); };
            setTimeout(function () { img.classList.remove('av-cambiando'); }, 500);
          }, 250);
        }
      }
      items.forEach(function (item) {
        item.addEventListener('click', function () { activar(item); });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activar(item); }
        });
      });
      if (window.matchMedia('(min-width: 990px)').matches && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) activar(e.target); });
        }, { rootMargin: '-45% 0px -45% 0px' });
        items.forEach(function (i) { io.observe(i); });
      }
    });
  }

  function initComparador(root) {
    (root || document).querySelectorAll('[data-av-comp]').forEach(function (marco) {
      var rango = marco.querySelector('.av-comp__rango');
      if (!rango) return;
      function set() { marco.style.setProperty('--av-pos', rango.value + '%'); }
      rango.addEventListener('input', set);
      set();
    });
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('[data-av-galeria]').forEach(function (g) {
      var principal = g.querySelector('.av-pp__principal img');
      var minis = g.querySelectorAll('.av-pp__mini');
      if (!principal || !minis.length) return;
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          minis.forEach(function (x) { x.classList.remove('av-activo'); });
          m.classList.add('av-activo');
          principal.classList.add('av-cambiando');
          setTimeout(function () {
            principal.src = m.getAttribute('data-src');
            principal.removeAttribute('srcset');
            principal.alt = m.getAttribute('data-alt') || '';
            principal.classList.remove('av-cambiando');
          }, 180);
        });
      });
    });
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-av-producto]').forEach(function (sec) {
      var form = sec.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var btn = sec.querySelector('[data-av-add]');
      var btnTexto = btn ? btn.querySelector('span') : null;
      var precio = sec.querySelector('[data-av-precio]');
      var antes = sec.querySelector('[data-av-antes]');
      var ahorro = sec.querySelector('[data-av-ahorro]');
      var dataEl = sec.querySelector('[data-av-variantes]');
      var variantes = [];
      try { variantes = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variantes = []; }
      var textoAdd = btn ? btn.getAttribute('data-texto') : '';
      var textoAgotado = btn ? btn.getAttribute('data-agotado') : '';
      var formatMoney = function (c) {
        var moneda = sec.getAttribute('data-moneda') || 'EUR';
        try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: moneda }).format(c / 100); }
        catch (e) { return (c / 100).toFixed(2) + ' ' + moneda; }
      };

      // Cantidad
      var qty = sec.querySelector('.av-cantidad input');
      sec.querySelectorAll('[data-av-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = parseInt(qty.value, 10) || 1;
          v = b.getAttribute('data-av-qty') === '+' ? v + 1 : Math.max(1, v - 1);
          qty.value = v;
        });
      });

      // Variantes
      var grupos = sec.querySelectorAll('[data-av-opcion]');
      if (grupos.length && variantes.length) {
        sec.addEventListener('change', function (e) {
          if (!e.target.closest('[data-av-opcion]')) return;
          var sel = [];
          grupos.forEach(function (g) {
            var c = g.querySelector('input:checked');
            sel.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) {
            return x.options.every(function (o, i) { return o === sel[i]; });
          });
          if (!v) {
            if (btn) { btn.disabled = true; if (btnTexto) btnTexto.textContent = textoAgotado; }
            return;
          }
          idInput.value = v.id;
          if (precio) precio.textContent = formatMoney(v.price);
          if (antes) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              antes.textContent = formatMoney(v.compare_at_price); antes.hidden = false;
              if (ahorro) { ahorro.hidden = false; ahorro.textContent = ahorro.getAttribute('data-prefijo') + ' ' + formatMoney(v.compare_at_price - v.price); }
            } else { antes.hidden = true; if (ahorro) ahorro.hidden = true; }
          }
          if (btn) {
            btn.disabled = !v.available;
            if (btnTexto) btnTexto.textContent = v.available ? textoAdd : textoAgotado;
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      }

      // Añadir al carrito con el carrito de Dawn (si existe), o envío normal
      form.addEventListener('submit', function (e) {
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return;
        e.preventDefault();
        if (btn) btn.setAttribute('aria-busy', 'true');
        var errorEl = sec.querySelector('.av-pp__error');
        if (errorEl) errorEl.hidden = true;
        var fd = new FormData(form);
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        cart.setActiveElement && cart.setActiveElement(document.activeElement);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') , {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) {
            if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.hidden = false; }
            return;
          }
          cart.renderContents(res);
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        }).catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
      });

      // Barra fija de compra en móvil
      var sticky = sec.querySelector('.av-pp__sticky');
      var zona = sec.querySelector('.av-pp__compra');
      if (sticky && zona && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
            sticky.classList.toggle('av-visible', pasado);
          });
        }).observe(zona);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          if (btn && !btn.disabled) btn.click();
          else zona.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  function initAll(root) {
    initReveals(root); initCifras(root); initCabezales(root);
    initComparador(root); initGaleria(root); initProducto(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document); initParallax();
    if (reduce) document.querySelectorAll('.av-hero__video').forEach(function (v) { v.pause(); v.removeAttribute('autoplay'); });
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
